import rawProducts from "./products.json";

const processedProducts = rawProducts.map(product => {
  const colourVariants = product.ColourVariants
    ? product.ColourVariants.split(",")
    : [];

  const turnOptions = product.TurnOption
    ? product.TurnOption.split(",")
    : [];

  const imageName =
    colourVariants.length > 0
      ? `${product.Image} ${colourVariants[0].toUpperCase()}.webp`
      : `${product.Image}.webp`;

  return {
    ...product,

    // Preserve original image base name
    ImageBase: product.Image,

    // Keep old code working
    Image: imageName,

    // Convert strings to arrays
    ColourVariants: colourVariants,
    TurnOption: turnOptions
  };
});

export default processedProducts;